<template>
  <div class="help-view p-4">
    <div v-if="entry === undefined" class="text-muted">Loading...</div>
    <div v-else-if="visibleEntry === null" class="text-muted">No help available for this page.</div>
    <div v-else>
      <div v-if="userIsAdmin && !entry.published" class="draft-badge">Draft</div>
      <h3>{{ entry.title }}</h3>
      <div v-html="renderedBody" class="help-body"></div>
    </div>
  </div>
</template>

<script>
import {markdownToHtml} from '@/utils/markdownToHtml';

export default {
  name: 'HelpViewPage',
  computed: {
    entry() { return this.$store.getters['help/getByKey'](this.$route.params.key); },
    renderedBody() {
      return this.entry ? markdownToHtml(this.entry.bodyMd) : '';
    },
    userIsAdmin() {
      var roles = this.$store.state.user.roles;
      if (!roles) return false;
      var list = Array.isArray(roles) ? roles : String(roles).split(',');
      return list.some(function (r) {
        return r.trim() === 'admin';
      });
    },
    visibleEntry() {
      if (this.entry === undefined || this.entry === null) return this.entry;
      if (!this.entry.published && !this.userIsAdmin) return null;
      return this.entry;
    }
  },
  created() {
    this.$store.dispatch('help/fetchByKey', this.$route.params.key);
  }
}
</script>

<style scoped>
.draft-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #856404;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 3px;
  padding: 1px 6px;
  margin-bottom: 6px;
}
</style>
